<template>
  <div class="swiper-home-bottom">
    <div class="swiper-container" :class="containerClass.slice(1)">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in msgList" :key="item.id">
          <div class="img-box">
            <img :src="item.imgurl" alt="" />
            <div
              class="number-box"
              :class="{ 'number-box-display': numberBox }"
            >
              {{ item.index }}
            </div>
            <div class="bgc" v-if="item.productList"></div>
            <ul class="products" v-if="item.productList">
              <li v-for="pitem in item.productList" :key="pitem.id">
                {{ pitem.text }}
              </li>
            </ul>
          </div>
          <div class="news-title">
            {{ item.title }}
          </div>
          <div class="msg">
            {{ item.msg }}
          </div>
          <!-- <div class="link" @click="$router.push(item.path)">
            Discover
            <div class="icon">
              <svg-icon iconClass="home-right-arrow"></svg-icon>
            </div>
          </div> -->
          <a class="link" href="mailto:info@cmr.xyz">
            {{ linkText }}
            <div class="icon">
              <svg-icon iconClass="home-right-arrow"></svg-icon>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { getItem } from "@/utils/localStorage";
export default {
  props: {
    /**
     * msg列表数据
     */
    msgList: {
      type: Array,
      default: [],
    },
    swiperID: {
      type: String,
      default: "",
    },
    titleSize: {
      type: String,
      default: "normal",
    },
    numberBox: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      swiperNum: 0,
      linkText: "",
    };
  },
  mounted() {
    let docEl = document.documentElement;
    let clientWidth = docEl.clientWidth;
    if (clientWidth <= 760) {
      this.swiperNum = 2;
    } else {
      this.swiperNum = 4;
    }
    let mySwiper = new Swiper(this.containerClass, {
      slidesPerView: this.swiperNum,
      spaceBetween: 10,
      freeMode: true,
      autoplay: {
        disableOnInteraction: false,
      },
      mousewheel: true,
    });
    mySwiper.el.onmouseover = function () {
      mySwiper.autoplay.stop();
    };
    mySwiper.el.onmouseout = function () {
      mySwiper.autoplay.start();
    };
    if (getItem("language") == "zh-cn") {
      this.linkText = "联系我们";
    } else {
      this.linkText = "Connect Us";
    }
  },
  computed: {
    containerClass() {
      return ".swiper-container" + this.swiperID;
    },
  },
};
</script>

<style lang="less" scoped>
.swiper-home-bottom {
  background-color: #ffffff;
  .swiper-container {
    margin-left: 2.6rem;
    margin-right: 2.6rem;
    // overflow: hidden;
    .swiper-wrapper {
      .swiper-slide {
        &:hover {
          .img-box {
            .number-box {
              background-color: #b94060;
            }
          }
        }
        .img-box {
          position: relative;
          width: 100%;
          img {
            width: 100%;
            height: 100%;
          }
          .number-box {
            position: absolute;
            right: 0;
            bottom: 0;
            font-size: 0.1546rem;
            text-align: center;
            line-height: 1rem;
            width: 1rem;
            height: 1rem;
            transition: all 0.5s ease-in-out;
            background-color: #ffffff;
          }
          .number-box-display {
            display: none;
          }
          .bgc {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            background: rgba(0, 0, 0, 0.25);
          }
          .products {
            position: absolute;
            left: 15%;
            bottom: 5%;
            li{
              color: #ffffff;
              list-style: disc ;
              font-weight: 700;
            }
          }
        }
        .news-title {
          font-size: 0.22rem;
          line-height: 1.5;
          font-weight: 700;
          // margin: 0rem 0;
          margin-top: 0.1rem;
          text-align: left;
        }
        .msg {
          // margin-bottom: 0.1rem;
          text-align: left;
        }
        .link {
          color: #000;
          font-size: 0.22rem;
          display: flex;
          // line-height: 1.5;
          // height: 0.3rem;
          // margin-top: 0.1rem;
          vertical-align: middle;
          align-items: center;
          // justify-content: space-between;
          transition: all 0.5s ease-in-out;
          .icon {
            margin-left: 0.3rem;
            margin-top: 0.03rem;
            display: flex;
            font-size: 0.25rem;
            align-items: center;
          }
          &:hover {
            cursor: pointer;
            color: #b94060;
            font-size: 0.25rem;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 760px) {
  .swiper-home-bottom {
    .swiper-container {
      margin-right: 0rem;
      padding-left: 0;
      margin-left: 0rem;
      .swiper-wrapper {
        .swiper-slide {
          .news-title {
            font-size: 0.3rem;
          }
          .link {
            font-size: 0.25rem;
          }
          .img-box{
            .products{
              li{
                font-size: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
